import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
import { Draggable } from "gsap/all";
import Experience from "../Experience";

export default class Animation {
  constructor() {
    this.experience = new Experience();
    this.timeline;
    this.cards;
    this.dragInteraction;

    this.animationSetup();
    this.interactionSetup();
    this.addInteraction();
  }

  animationSetup() {
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.defaults({
      immediateRender: false,
      ease: "power1.inOut",
      scrub: true,
    });

    this.timeline = gsap.timeline({
      scrollTrigger: {
        trigger: ".app",

        start: "start",
        end: "bottom",
        scrub: true,
        // markers: true,
      },
    });

    this.timeline.addLabel("start", 0);
    this.timeline.to(".app", { opacity: 0.25 }, "start");
  }

  interactionSetup() {
    gsap.registerPlugin(Draggable);
  }

  addInteraction() {
    this.cards = gsap.utils.toArray(".card");

    this.cards.forEach((card) => {
      card.style.left = `${(Math.random() - 0.1) * 80}%`;
      card.style.top = `${(Math.random() - 0.1) * 80}%`;
    });
    this.dragInteraction = Draggable.create(".card", {
      type: "x,y",
      edgeResistance: 0.65,
      bounds: ".container",
      inertia: true,
    });
  }

  removeInteraction() {
    this.cards.forEach((card) => {
      card.removeAttribute("style");
    });
    this.dragInteraction.forEach((d) => d.kill());
  }
  resize() {
    if (window.innerWidth > 1200) {
      this.addInteraction();
    } else {
      this.removeInteraction();
    }
  }
}
